import { useState } from 'react';
import { cn } from '@/lib/utils';
import { KpisSection } from './_components/kpis-section';
import { TrainingSection } from './_components/training-section';
import { ComplianceSection } from './_components/compliance-section';
import { MatrixSection } from './_components/matrix-section';

type TabKey = 'kpis' | 'training' | 'compliance' | 'matrix';

export function ReportsPage() {
  const [tab, setTab] = useState<TabKey>('kpis');

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Reportes</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Métricas y reportes de capacitación y cumplimiento.
        </p>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 overflow-x-auto rounded-lg bg-muted p-1">
        {(
          [
            { key: 'kpis', label: 'KPIs' },
            { key: 'training', label: 'Capacitación' },
            { key: 'compliance', label: 'Cumplimiento' },
            { key: 'matrix', label: 'Matriz' },
          ] as const
        ).map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={cn(
              'flex-1 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors',
              tab === t.key
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'kpis' && <KpisSection />}
      {tab === 'training' && <TrainingSection />}
      {tab === 'compliance' && <ComplianceSection />}
      {tab === 'matrix' && <MatrixSection />}
    </div>
  );
}
